import { render, staticRenderFns } from "./EditFolderModal.vue?vue&type=template&id=9b7213f8"
import script from "./EditFolderModal.vue?vue&type=script&lang=js"
export * from "./EditFolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports